<template>
  <el-dialog
          title="平台用户"
          :visible.sync="dialogVisible"
          customClass="customWidth"
          @opened="dialogOpen"
  >
    <div class="header" flex="main:justify cross:center">
    <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            size="mini"
            style="margin-bottom: -18px;"
    >

      <el-form-item
              label="会员姓名"
      >
        <el-input
                v-model="searchForm.legal"
                placeholder="会员姓名"
                style="width: 100px;"
        />
      </el-form-item>
      <el-form-item
              label="电话号码"
      >
        <el-input
                v-model="searchForm.userCode"
                placeholder="电话号码"
                style="width: 120px;"
        />
      </el-form-item>
      <el-form-item
              label="会员ID"
      >
        <el-input
                v-model="searchForm.member_id"
                placeholder="会员ID"
                style="width: 100px;"
        />
      </el-form-item>
      <el-form-item>
        <el-date-picker
                v-model="dateRange"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"    width="150">

        </el-date-picker>

      </el-form-item>
      <el-form-item
              label="分享人电话号码"
      >
        <el-input
                v-model="searchForm.fxtel"
                placeholder="分享人电话号码"
                style="width: 120px;"
        />
      </el-form-item>
      <el-form-item
              label="顾客编号"
      >
        <el-input
                v-model="searchForm.user_agentid"
                placeholder="顾客编号"
                style="width: 120px;"
        />
      </el-form-item>



      <el-form-item>
        <el-button
                type="primary"
                @click="handleSearchFormSubmit"
        >
          <d2-icon name="search" /> 查询
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button @click="handleSearchFormReset">
          <d2-icon name="refresh" /> 重置
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button
                type="primary"
                @click="handleSearchFormSubmitQr"
        >
          <d2-icon name="search" /> 确定
        </el-button>
      </el-form-item>
    </el-form>
    </div>
    <el-table
            :data="tableData"
            v-loading="loading"
            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >
      <el-table-column
              type="selection"
              width="55"
      >
      </el-table-column>
      <el-table-column
              label="顾客编号"
      >
        <template slot-scope="scope">
          {{scope.row.agentid}}
        </template>
      </el-table-column>

      <el-table-column
              label="微信呢称"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.userName}}
        </template>
      </el-table-column>
      <el-table-column
              label="微信图像"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.avatarUrl!=null && scope.row.avatarUrl!=''">
            <img :src= "getImgUrl3(scope.row)" style="width: 100px;height: 100px; "/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="平台账号类型"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.agenttype=='1'">
            普通用户
          </div>
          <div v-else-if="scope.row.agenttype=='2'">
            <div v-if="scope.row.dl_type=='-1'">
              平台
            </div>
            <div v-else-if="scope.row.dl_type=='0'">
              全国代理
            </div>
            <div v-else-if="scope.row.dl_type=='1'">
              运营商
            </div>
            <div v-else-if="scope.row.dl_type=='2'">
              服务商
            </div>
            <div v-else-if="scope.row.dl_type=='5'">
              运营中心
            </div>
            <div v-else-if="scope.row.dl_type=='4'">
              商家
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="会员姓名"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>
      <el-table-column
              label="会员ID"
      >
        <template slot-scope="scope">
          {{scope.row.member_id}}
        </template>
      </el-table-column>

      <el-table-column
              label="手机号"
      >
        <template slot-scope="scope">
          {{scope.row.mobileNo}}
        </template>
      </el-table-column>
      <el-table-column
              label="注册时间"
      >
        <template slot-scope="scope">
          {{scope.row.create_times}}
        </template>
      </el-table-column>
      <el-table-column
              label="分享人手机号码"
      >
        <template slot-scope="scope">
          {{scope.row.tjagentid}}
        </template>
      </el-table-column>
      <el-table-column
              label="分享人账号类型"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.qrcodeid=='1'">
            顾客
          </div>
          <div v-else-if="scope.row.qrcodeid=='2'">
            商家或代理
          </div>

        </template>
      </el-table-column>


    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:90%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import * as memberService from "@/api/sys/member";
    import util from '@/libs/util.js'
    export default {
        name: "threeagentEditForm",
        props: {
            agentid: String,
            value: Boolean
        },
        data() {
            return {
              searchForm: {
                fxtel: "",
                legal: "",
                member_id: "",
                user_agentid: "",
                userCode: ""
              },
              loading: false,
              dialogVisible: false,
              is_agentid:util.cookies.get('agentid'),
              tableData: [],
              multipleSelection: [],
              dateRange: [],
              pickerOptions:{},
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                sort: {
                    prop: "",
                    order: ""
                }
            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
            },
            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            dateConversion(value){
                var d = new Date(value);
                //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
                var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                console.info("===========date========="+date);
                return date;
            },
          getImgUrl3(row){
            var good_url=row.avatarUrl;
            if(good_url.match(",")){
              var str = good_url.split(',');
              good_url=str[1];
            }

            return good_url;
          },
            dialogOpen() {
                this.$refs.searchForm.resetFields();
                this.getTableData();


            },

            getTableData() {
              let startt="";
              let endt="";
              if(this.dateRange!=null && this.dateRange!=""){
                startt=this.dateConversion(this.dateRange[0]);
                endt=this.dateConversion(this.dateRange[1]);
              }
              let query = {
                pageIndex: this.page.current,
                pageSize: this.page.size,
                sortBy: this.sort.prop,
                dl_type: '-1',
                xt_id: '589e2db5-94d7-4405-80a2-7e100d14a9de',
                agentid: '70800072265441',
                startTime:startt,
                endTime:endt,
                descending: this.sort.order === "descending",
                filter: this.searchForm
              };
              memberService.getMemberPageList(query).then(data => {
                this.tableData = data.rows;
                this.page.total = data.totalCount;
              });
            },
            handleSearchFormSubmit() {
              this.page.current=1;
                this.getTableData();
            },
            handleSearchFormReset() {
                this.$refs.searchForm.resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSortChange(val) {
                this.sort.prop = val.prop;
                this.sort.order = val.order;
                this.getTableData();
            },
            handleSizeChange(val) {
                this.page.size = val;
                this.getTableData();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getTableData();
            },
          handleSearchFormSubmitQr() {
            let iddd=JSON.stringify(this.multipleSelection.map(s => s.agentid));
            this.$confirm("确认添加？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: "确认",
              cancelButtonText: "取消"
            }).then(() => {
              memberService
                      .qrMemberglBath({
                        ids: iddd.substring(1, iddd.length-1).replaceAll("\"", ""),
                        agentid: util.cookies.get('agentid')
                      })
                      .then(() => {
                        this.dialogVisible = false;
                        this.$emit("submit");
                      });
            });

          },
            close() {

              this.$refs["searchForm"].resetFields();
              this.dialogVisible = false;


            }
        }
    };
</script>
<style lang="scss" scoped>
  .header {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .header2 {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
